import React, { useState, useRef, useEffect } from 'react';
// import { ChevronDown, ChevronUp, Check } from 'react-bootstrap-icons';
import { ReactComponent as ChevronDown } from '../../assets/images/icons/ChevronDown_16.svg';
import { ReactComponent as ChevronUp } from '../../assets/images/icons/ChevronUp_16.svg';
import { ReactComponent as Check_Grayscale80 } from '../../assets/images/icons/Check_Grayscale80.svg';
import { constants } from '../../helpers/';

import './SortingPicker.scss';
const SortingPicker = ({ onSortChange, sortOrder = 'newest' }) => {
  const [showSortPicker, setShowSortPicker] = useState(false);
  const [selectedSort, setSelectedSort] = useState(sortOrder);
  const [sortingOptionVisible, setSortingOptionVisible] = useState(false);
  const sortPickerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      sortPickerRef.current &&
      !sortPickerRef.current.contains(event.target)
    ) {
      setShowSortPicker(false);
      setSortingOptionVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!sortOrder || typeof sortOrder !== 'string') return;

    setSelectedSort(sortOrder.toLowerCase());
  }, [sortOrder]);

  const handleSortChange = (sortType) => {
    setSelectedSort(sortType);
    setShowSortPicker(false);
    onSortChange(sortType);
    setSortingOptionVisible(false);
  };

  return (
    <div className="sorting-picker-container" ref={sortPickerRef}>
      <div
        className="event-sorting-section"
        onClick={() => {
          setShowSortPicker(!showSortPicker);
          setSortingOptionVisible(!showSortPicker);
        }}
        onBlur={() => {
          setShowSortPicker(false);
          setSortingOptionVisible(false);
        }}
      >
        <div className="event-sorting-inner-section">
          <div className="sorting-style">
            <span className={sortingOptionVisible === true ? 'active' : ''}>
              {constants.SORTING_PICKER_SORT_PREFIX}{' '}
              {selectedSort === 'oldest'
                ? constants.SORTING_PICKER_OLDEST_TO_NEWEST
                : constants.SORTING_PICKER_NEWEST_TO_OLDEST}
            </span>
          </div>
        </div>
        <span className="toggle-sorting-picker">
          {showSortPicker ? (
            <ChevronUp
              className={`dark-theme-icon ${
                sortingOptionVisible === true ? 'active' : ''
              }`}
            />
          ) : (
            <ChevronDown
              className={`dark-theme-icon ${
                sortingOptionVisible === true ? 'active' : ''
              }`}
            />
          )}
        </span>
      </div>
      {showSortPicker && (
        <div className="sort-picker-events">
          {/* Newest to Oldest */}
          <div
            className="sort-option"
            onClick={() => handleSortChange('newest')}
          >
            <span className={selectedSort === 'newest' ? 'selected' : ''}>
              {constants.SORTING_PICKER_NEWEST_TO_OLDEST}
            </span>
            {selectedSort === 'newest' && <Check_Grayscale80 />}
          </div>
          {/* Oldest to Newest */}
          <div
            className="sort-option"
            onClick={() => handleSortChange('oldest')}
          >
            <span className={selectedSort === 'oldest' ? 'selected' : ''}>
              {constants.SORTING_PICKER_OLDEST_TO_NEWEST}
            </span>
            {selectedSort === 'oldest' && <Check_Grayscale80 />}
          </div>
        </div>
      )}
    </div>
  );
};

export default SortingPicker;
